import React, { useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import api from "@/lib/api";
import { track } from "@/lib/track";
import { Button, Spinner } from "@/components/ui-kit";
import { APP } from "@/config";
import { CheckCircle2, ArrowRight, AlertCircle } from "lucide-react";

export default function ConfirmLead() {
  const [params] = useSearchParams();
  const nav = useNavigate();
  const token = params.get("token");
  const [state, setState] = useState("loading"); // loading | ok | error

  useEffect(() => {
    if (!token) { setState("error"); return; }
    api.post("/leads/confirm", { token })
      .then(() => { setState("ok"); track("lead_confirmed_page", {}); })
      .catch(() => setState("error"));
  }, [token]);

  return (
    <div className="band-3-5 min-h-screen bg-[var(--ns-bg)] grid place-items-center px-5">
      <motion.div initial={{ opacity: 0, y: 12 }} animate={{ opacity: 1, y: 0 }}
        className="w-full max-w-md bg-[var(--ns-surface)] rounded-[var(--ns-radius)] border border-[var(--ns-border)] p-8 text-center ns-card" data-testid="confirm-lead-page">
        <div className="flex items-center justify-center gap-2 mb-6">
          <div className="w-9 h-9 rounded-xl bg-[var(--ns-primary)] text-white grid place-items-center font-head font-bold">N</div>
          <span className="font-head text-lg font-bold">{APP.name}</span>
        </div>
        {state === "loading" && <Spinner label="Confirming your email" />}
        {state === "ok" && (
          <>
            <CheckCircle2 size={48} className="mx-auto text-[#2A8555]" />
            <h1 className="font-head text-2xl font-bold mt-3">You're all set! 🎉</h1>
            <p className="text-[var(--ns-muted)] mt-2">Your Math Readiness Checklist is on its way to your inbox, and your 5-day "Math at Home" series starts now.</p>
            <Button className="mt-6 mx-auto px-7" data-testid="confirm-diagnostic-cta" onClick={() => { track("confirm_diagnostic_cta", {}); nav("/diagnostic"); }}>
              Take the free 5-minute check <ArrowRight size={18} />
            </Button>
          </>
        )}
        {state === "error" && (
          <>
            <AlertCircle size={48} className="mx-auto text-[#B23A28]" />
            <h1 className="font-head text-2xl font-bold mt-3">Link not valid</h1>
            <p className="text-[var(--ns-muted)] mt-2">This confirmation link is invalid or has already been used. You can request the checklist again from our home page.</p>
            <Button variant="outline" className="mt-6 mx-auto" onClick={() => nav("/")}>Back to home</Button>
          </>
        )}
      </motion.div>
    </div>
  );
}
